import { autoGeneratedReducer } from '@hh.ru/redux-create-reducer';

import Filter from 'src/constants/filter';
import Report from 'src/constants/report';

export type ReportColumns = Array<{
    name: string;
    isGroup?: boolean;
    defaultHidden?: boolean;
}>;

type ReportsConfig = Record<
    Report,
    {
        filters?: Filter[];
        columns?: ReportColumns;
    }
>;

export default autoGeneratedReducer<ReportsConfig>({} as ReportsConfig);
